// extracted by mini-css-extract-plugin
export var cardLayout = "_9m-1";
export var paginationContainer = "_9m-0";